import React, { useContext } from 'react';
import { Route } from 'react-router';
import { Switch, Redirect } from 'react-router-dom';

import { AuthContext } from '../contexts/AuthContext';
import { NavContext, NavRoutes } from '../contexts/NavContext';
import { UserContext } from '../contexts/UserContext';

import { ApplicationRoles } from '../../helpers';

import {
    HomePage,
    NotFoundPage,
    ForbiddenPage,
    TableContentPage,
    DownloadExportPage,
    RolePage,
    RoleUsersPage,
    RoleUserPage,
    TablePage,
    TableUsersPage
} from '../pages';

const ProtectedRoute = ({ ...props }) => {

    const {
        isAuthenticated,
        getAccountInfo
    } = useContext(AuthContext);

    const {
        getCurrentUserInfo,
        isUserInRole,
        isUserInRoles
    } = useContext(UserContext);

    const isPathAllowed = (path) => {

        if (isUserInRole(ApplicationRoles.Administrator))
            return true;

        switch (path) {

            case NavRoutes.Home:
            case NavRoutes.Forbidden:
            case NavRoutes.NotFound:
                return true;

            case NavRoutes.TableContent:
            case NavRoutes.DownloadExport:
                return isUserInRoles([
                    ApplicationRoles.Viewer,
                    ApplicationRoles.Editor
                ]);

            case NavRoutes.Admin.Dashboard:
            case NavRoutes.Admin.Roles:
            case NavRoutes.Admin.Role:
            case NavRoutes.Admin.RoleUsers:
            case NavRoutes.Admin.RoleUser:
            case NavRoutes.Admin.Tables:
            case NavRoutes.Admin.Table:
            case NavRoutes.Admin.TableUsers:
            case NavRoutes.Admin.Logs:
                return isUserInRole(ApplicationRoles.Administrator);
        }
    }

    const accountInfo = getAccountInfo();
    const userInfo = getCurrentUserInfo();
    if (isAuthenticated() && userInfo && isPathAllowed(props.path)) {
        return <Route {...props} />;
    } else {
        return <Redirect to={NavRoutes.Forbidden} />;
    }
}

export const Routes = ({ ...props }) => {
    const { menuItems } = useContext(NavContext);

    return (
        <Switch>

            {menuItems && menuItems.map((item, index) => {
                if (item.isProtected) {
                    return <ProtectedRoute key={index} exact path={item.routePath} component={item.component} />
                } else {
                    return <Route key={index} exact path={item.routePath} component={item.component} />
                }
            })}

            <ProtectedRoute exact path={NavRoutes.TableContent} component={TableContentPage} />

            <ProtectedRoute exact path={NavRoutes.DownloadExport} component={DownloadExportPage} />

            <ProtectedRoute exact path={NavRoutes.Admin.Role} component={RolePage} />
            <ProtectedRoute exact path={NavRoutes.Admin.RoleUsers} component={RoleUsersPage} />
            <ProtectedRoute exact path={NavRoutes.Admin.RoleUser} component={RoleUserPage} />

            <ProtectedRoute exact path={NavRoutes.Admin.Table} component={TablePage} />
            <ProtectedRoute exact path={NavRoutes.Admin.TableUsers} component={TableUsersPage} />

            <Route exact path={NavRoutes.Forbidden} component={ForbiddenPage} />

            <Route component={NotFoundPage} />

        </Switch>
    );
}